var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcClear = function SvgIcClear(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 30")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work_details-v2",
    transform: "translate(-985.000000, -1537.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(698.000000, 545.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(163.000000, 986.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(124.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    fill: "#F1F1F1",
    x: 0,
    y: 0,
    width: 12,
    height: 12,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)",
    fill: "#7B7B7B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_close"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7070584,1.77273071 C6.85729209,1.91492174 6.86381195,2.15197881 6.72162092,2.30221249 L6.7064659,2.31733456 L6.7064659,2.31733456 L4.74333333,4.16666667 L6.7064659,6.01599877 C6.85700862,6.15786257 6.86404428,6.39490489 6.72218047,6.54544761 C6.71728522,6.55064235 6.71224247,6.55569608 6.7070584,6.56060263 C6.54538591,6.71362009 6.29240018,6.71389533 6.13039512,6.56123 L4.16633333,4.70966667 L2.20293821,6.56123 C2.04093316,6.71389533 1.78794742,6.71362009 1.62627493,6.56060263 C1.47604125,6.4184116 1.46952139,6.18135453 1.61171242,6.03112084 C1.61661896,6.02593677 1.6216727,6.02089402 1.62686743,6.01599877 L3.58933333,4.16666667 L1.62686743,2.31733456 C1.47632471,2.17547076 1.46928906,1.93842844 1.61115286,1.78788572 L1.62627493,1.77273071 L1.62627493,1.77273071 C1.78794742,1.61971324 2.04093316,1.61943801 2.20293821,1.77210333 L4.16633333,3.62266667 L6.13039512,1.77210333 C6.29240018,1.61943801 6.54538591,1.61971324 6.7070584,1.77273071 Z",
    id: "close"
  }))))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcClear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_clear.8af0839d.svg";
export { ForwardRef as ReactComponent };